const IGNORED_RUNTIME_ERROR_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

export function shouldIgnoreRuntimeErrorMessage(message: string): boolean {
  const normalizedMessage = message.trim();
  return IGNORED_RUNTIME_ERROR_MESSAGES.some(
    (ignoredMessage) => normalizedMessage === ignoredMessage
  );
}
